import React from "react";
import { IQuestionControlProps } from "shared/containers";

export const NoAnswerControl: React.FC<IQuestionControlProps> = (props) => {
	return <div></div>;
};
